export default __webpack_public_path__ + "static/media/course_bg.7b39aab6.svg";